module.exports = __webpack_public_path__ + "media/icons/close-fc5cb96c.png";